import { render, staticRenderFns } from "./posterAtlas.vue?vue&type=template&id=4154ad95&scoped=true&"
import script from "./posterAtlas.vue?vue&type=script&lang=js&"
export * from "./posterAtlas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4154ad95",
  null
  
)

export default component.exports